import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { rejectBooking } from '../../../api/sportaloka-client';
import { useParams } from 'react-router-dom';

const RejectModal = ({ resetData }) => {
  const { id } = useParams();
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (!reason) {
      Swal.fire({
        title: 'Gagal!',
        text: `Alasan penolakan wajib diisi`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      return false;
    }
    Swal.fire({
      title: 'Apakah anda yakin ingin menolak pesanan ini?',
      text: 'Aksi ini tidak dapat dikembalikan',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya',
      cancelButtonText: 'Tidak'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          await rejectBooking(id, reason);
          document.getElementById('closeModal').click();
          resetData();
          Swal.fire({
            title: 'Berhasil!',
            text: `Pesanan telah ditolak`,
            icon: 'success',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: `Periksa koneksi internet anda`,
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        }
      }
    });
  };

  useEffect(() => {
    const handleModalHidden = () => {
      setReason('');
    };

    const modalElement = document.getElementById('rejectBookingModal');
    modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
    };
  }, []);
  return (
    <div className="modal" tabIndex="-1" id="rejectBookingModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-600 text-16">Tolak Pesanan</h5>
            <button
              id="closeModal"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <label className="fw-500" htmlFor="">
              Alasan Penolakan
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="form-control"
              rows={3}
              style={{ resize: 'none', marginTop: 8, backgroundColor: '#f8f8f8' }}></textarea>
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button
              disabled={loading}
              onClick={handleSubmit}
              type="button"
              className="btn btn-primary bg-blue-1 rounded-1 fw-600">
              {loading ? 'Loading...' : 'Submit'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectModal;
